export function getBeginingOfWeekInMs(arg: Date | number) {
  const d = new Date(arg);
  var day = d.getDay(),
    diff = d.getDate() - day + (day === 0 ? -6 : 1);
  // adjust when day is sunday
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);
  d.setDate(diff);
  return d.getTime();
}
export function getBeginingOfDayInMs(arg: Date | number) {
  const d = new Date(arg);
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d.getTime();
}
export const DAYS = ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"];
export const DAY_LENGTH = 24 * 60 * 60 * 1000;
